import React, { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom"
import './main.css'
import mainIntro from "assets/images/new_main_intro.mp4"
import sea from "assets/images/sea.png";
import mobile_sea from "assets/images/mobile_sea.png";
import topTransparencyLayer from "assets/images/top_transparency_layer.png"
import bottomTransparencyLayer from "assets/images/bottom_transparency_layer.png"
import rightArrow from "assets/images/svg/new_main_right_arrow.svg"
import mainSection1 from "assets/images/main_section1.jpg"
import mainSection2 from "assets/images/main_section2.jpg"
import mainSection3 from "assets/images/main_section3.jpg"
import mainSection4 from "assets/images/main_section4.jpg"
import mainSection5 from "assets/images/main_section5.jpg"
import mainSection6 from "assets/images/main_section6.jpg"
import mainSection7 from "assets/images/main_section7.jpg"
import mainSection8 from "assets/images/main_section8.jpg"
import mainSection9 from "assets/images/main_section9.jpg"
import mainSection10 from "assets/images/main_section10.jpg"
import mainSection11 from "assets/images/main_section11.jpg"
import mainSection12 from "assets/images/main_section12.jpg"
import logoWhite from "assets/images/new_main_logo_white.png";
import orangeTopArrow from "assets/images/svg/orange_top_arrow.svg"
import blueBottomArrow from "assets/images/svg/blue_bottom_arrow.svg"
import greenBottomArrow from "assets/images/svg/green_bottom_arrow.svg"
import whiteRightArrow from "assets/images/svg/new_main_white_right_arrow.svg"
import storeEntry from "assets/images/svg/main_store_entry.svg"
import inquiry from "assets/images/svg/main_inquiry.svg"
import logo from "assets/images/menubar_logo.png"

const BusinessIntroduction = () => {
  const videoRef = useRef(null)
  const history = useHistory()
  const divRefs = useRef([]);
  const [videoRendered, setVideoRendered] = useState(false)
  const [stage, setStage] = useState(0);

  const overlapSection = 2207 * (window.innerWidth / 1920)

  useEffect(() => {
    const delayArray = [
      { index: 18, delay: 400 },
      { index: 20, delay: 1500 },
      { index: 21, delay: 2000 },
      { index: 22, delay: 500 },
      { index: 23, delay: 1500 },
      { index: 24, delay: 500 },
    ];

    const getDelay = (idx) => {
      const found = delayArray.find((d) => d.index === idx);
      return found ? found.delay : 0;
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = divRefs.current.indexOf(entry.target);
            const delay = getDelay(index);

            setTimeout(() => {
              entry.target.classList.add("ropik-show");
              observer.unobserve(entry.target);
            }, delay);
          }
        });
      },
      { threshold: 0.3 }
    );

    divRefs.current.forEach((div) => {
      if (div) observer.observe(div);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleCanPlayThrough = () => {
      setTimeout(() => {
        setVideoRendered(true); // 1.5초 뒤 애니메이션 시작
      }, 500);
    };

    video.addEventListener("canplaythrough", handleCanPlayThrough, { once: true });

    video.play().catch(err => {
      console.warn("Video play failed", err);
    });

    return () => {
      video.pause();
      video.removeEventListener("canplaythrough", handleCanPlayThrough);
    };
  }, []);

  const section1 = [
    {
      title: `정확성과\n투명성`,
      img: mainSection1,
      content: 'IoT 기반 스마트 디바이스로 음식물류 폐기물의 실 배출량을 정확하게 측정하고, 모든 데이터를 실시간으로 플랫폼에 연동하여 배출자와 수거업체, 처리장 모두가 투명하게 정보를 공유할 수 있습니다. 이를 통해 비용 산정의 신뢰성을 높이고, 분쟁을 최소화하며, 음식물 쓰레기 관리의 투명성을 극대화합니다.'
    },
    {
      title: `업무의 디지털화 및\n효율성`,
      img: mainSection2,
      content: '기존의 수기 기록, 아날로그 방식에서 벗어나 수거·운반·처리 전 과정을 디지털화합니다. 전자계약, 실시간 차량관제, 자동 정산·신고 등 다양한 기능을 통해 업무 효율성을 극대화하고, 인력·시간·비용을 절감합니다. 이는 수거업체와 처리장, 배출자 모두에게 실질적 편익을 제공합니다.'
    },
    {
      title: `지속가능성(ESG) 및\n상생 가치`,
      img: mainSection3,
      content: '플랫폼을 통해 전국의 음식물 쓰레기 배출자, 수거업체, 처리업체를 하나로 연결하여, ESG(환경·사회·지배구조) 가치 실현을 지원합니다. 데이터 기반 탄소배출권 사업, 사회적 비용 절감, 친환경 경영 등 지속가능한 성장과 사회적 가치 창출을 동시에 추구합니다.'
    },
  ]

  const section2 = [
    {
      title: `IoT-Based Smart\nMeasurement Devices`,
      img: mainSection4,
      subTitle: 'IoT 기반 스마트 계측 디바이스',
      content: '웨이스트버스는 AI, 센서, RFID, 카메라, GPS, LTE 통신이 탑재된 휴대용 스마트 계측기를 통해 배출 현장에서 음식물류 폐기물의 실제 배출량을 자동으로 측정합니다. 이 데이터는 실시간으로 플랫폼에 전송되어 수기 입력의 오류를 없애고, 배출자와 수거업체 간의 투명한 정산이 가능합니다.'
    },
    {
      title: `Real-Time Tracking and\nTransparency`,
      img: mainSection5,
      subTitle: '실시간 추적 및 투명성 강화',
      content: 'GPS 기반 차량관제 시스템을 통해 배출자와 수거업체 모두 수거 현황을 실시간으로 모니터링할 수 있어, 불법 투기 방지 등 안전하고 합법적인 폐기물 처리가 가능합니다.'
    },
    {
      title: `Full Digitalization of\nWaste Management`,
      img: mainSection6,
      subTitle: '폐기물 관리 전 과정의 디지털화',
      content: '음식물 쓰레기의 배출부터 수거, 운반, 처리, 정산, 신고까지 모든 과정을 실시간 데이터로 연동합니다. 전자계약, 자동 정산, 실시간 차량관제(TMS), 신고 자동화 등 다양한 기능이 통합되어 업무 효율성과 투명성을 크게 높입니다.'
    },
    {
      title: `Scalability and\nESG Impact`,
      img: mainSection7,
      subTitle: '확장성 및 ESG 영향력',
      content: '전국 83만 개 음식물 배출 사업장에 적용 가능한 확장성을 갖추고 있으며, 비용 절감, 업무 효율화, 친환경 경영 등 지속가능한 환경 관리와 사회적 가치 실현을 동시에 추구합니다. 향후 재활용, 건설폐기물, 글로벌 시장까지 사업을 확장할 계획입니다.'
    },
    {
      title: `API Integration and\nData-Driven Services`,
      img: mainSection8,
      subTitle: 'API 연동 및 데이터 기반 부가서비스',
      content: '외부 행정 시스템(예: 올바로 시스템)과 API로 연동되어 과태료 예방, 규제 대응 등 추가적인 혜택을 제공합니다. 누적 데이터를 바탕으로 탄소배출권 거래 등 ESG 연계 신사업 확장도 가능합니다.'
    },
  ]

  const section3 = [
    {
      title: `Enhancing Transparency and\nEfficiency in Food Waste Management`,
      img: mainSection9,
      subTitle: '음식물 쓰레기 관리의 투명성과 효율성 제고',
      content: '웨이스트버스는AIoT기반의 스마트 계측기와 플랫폼을 통해 음식물 쓰레기의 배출부터 수거, 운반, 처리까지 모든 과정을 실시간으로 데이터화하고 디지털화합니다. 이를 통해 기존 아날로그 방식에서 발생하던 불투명한 정산, 부정확한 계량, 분쟁 등을 해소하며, 사회 전체의 음식물 쓰레기 관리의 투명성과 효율성을 크게 높입니다.'
    },
    {
      title: `Environmental Protection and\nCarbon Reduction`,
      img: mainSection10,
      subTitle: '환경 보호 및 탄소저감 효과',
      content: '정확한 배출량 측정과 데이터 기반 관리로 음식물 쓰레기 처리 과정에서 발생하는 불필요한 낭비와 사회적 비용을 줄이고, 탄소 배출 저감 등 친환경 경영을 실현할 수 있습니다. 향후 수집된 데이터를 바탕으로 탄소배출권 사업 등 ESG(환경·사회·지배구조) 연계 신사업으로 확장함으로써 지속가능한 환경 가치 창출에 기여합니다.'
    },
    {
      title: `Reducing Social Costs and\nFostering Sustainable Communities`,
      img: mainSection11,
      subTitle: '사회적 비용 절감 및 지속가능한 사회 실현',
      content: '디지털 전환을 통한 업무 효율화로 수거업체, 배출자, 처리장 모두의 인력·시간·비용 부담을 줄이고, 불필요한 분쟁과 행정비용을 감소시킵니다. 이는 사회 전체의 음식물 쓰레기 처리에 드는 사회적 비용 절감으로 이어지며, 궁극적으로 지속가능한 사회와 가치소비 문화 확산에 기여합니다.'
    },
    {
      title: `Community Engagement and\nLocal Economic Activation`,
      img: mainSection12,
      subTitle: '일자리 창출 및 지역경제 활성화',
      content: '플랫폼을 통한 새로운 일자리 창출, 지역 수거업체 및 처리장과의 상생 협력, 데이터 기반의 신사업(재활용, 건설폐기물 등) 확장 등으로 지역경제 활성화에도 긍정적 영향을 미칩니다.'
    },
  ]

  const section4 = [
    {
      title: `웨이스트버스 플랫폼에 입점을 원하시나요?`,
      icon: storeEntry,
      content: '음식물류 폐기물 배출자, 수집운반업체, 처리장 등\n다양한 파트너의 참여를 환영합니다.',
      button1: '지금 입점하기',
      click1: 'sec_3_3',
      button1Url: 'store-entry-information',
      button2: '제휴 문의하기',
      click2: 'sec_4_4',
      button2Url: 'customer-support',
    },
    {
      title: `도움이 필요하시거나 궁금한 점이 있으신가요?`,
      icon: inquiry,
      content: '고객지원팀이 플랫폼 사용, 입점, 기술 문의 등 모든 질문에\n신속하게 답변해드립니다.',
      button1: '고객센터 문의하기',
      click1: 'sec_4_4',
      button1Url: 'customer-support',
      button2: 'FAQ 바로가기',
      click2: 'sec_3_4',
      button2Url: 'store-entry-information',
    },
  ]

  const text1 = 'I n n o v a t i v e';
  const text2 = 'Food Waste Collection Platform';
  // const text2 = 'IOT디바이스로 측정하는 음식물류 폐기물 스마트 수거 혁신 플랫폼';
  // const text3 = '“ 웨 이 스 트 버 스 ”'

  const useWordAnimation = (start, text, timeout = 0, delay = 100) => {
    const textArray = text.split(' ');
    const [animatedIndices, setAnimatedIndices] = useState([]);

    useEffect(() => {
      if (!start)
        return;

      let index = 0
      let intervalId
      const timeoutId = setTimeout(() => {
        intervalId = setInterval(() => {
          setAnimatedIndices((prev) => [...prev, index])
          index++
          if (index >= textArray.length) {
            clearInterval(intervalId)
          }
        }, delay);
      }, timeout)

      return () => {
        clearTimeout(timeoutId)
        clearInterval(intervalId)
      }
    }, [start, text])

    return { textArray, animatedIndices }
  }

  const { textArray: animationTextArray1, animatedIndices: animatedIndices1 } = useWordAnimation(videoRendered, text1)
  const { textArray: animationTextArray2, animatedIndices: animatedIndices2 } = useWordAnimation(videoRendered, text2, 1500)
  // const { textArray: animationTextArray3, animatedIndices: animatedIndices3 } = useWordAnimation(videoRendered, text3, 500)

  useEffect(() => {
    let t1, t2;

    if (videoRendered) {
      t1 = setTimeout(() => {
        setStage(1)
        t2 = setTimeout(() => {
          setStage(2)
        }, 1000)
      }, 3000)
    } else {
      setStage(0)
    }

    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
    };
  }, [videoRendered])

  return (
    <Fragment>
      <section id="sec_1_1" style={{ position: "relative", height: '100vh', width: '100%', overflow: "hidden" }}>
        <video ref={videoRef} className="video" loop autoPlay muted playsInline>
          <source src={mainIntro} type="video/mp4" />
        </video>
        <div className="business-main-text-container">
          {/* <p>
            {animationTextArray1.map((letter, index) => (
              <Fragment key={letter + index}>
                <span
                  className={`${animatedIndices1.includes(index) ? 'text-animated' : 'opacity-0'} business-main-text-1`}
                >
                  {letter + '\u00A0'}
                </span>
                {index === 2 && <br />}
              </Fragment>
            ))}
          </p> */}
          <p style={{ marginTop: 12 }}>
            {animationTextArray1.map((letter, index) => (
              <span key={letter + index} className={`${animatedIndices1.includes(index) ? 'text-animated' : 'opacity-0'} business-main-text-4`}>{letter}</span>
            ))}
          </p>
          <p style={{ marginTop: 12 }}>
            {animationTextArray2.map((letter, index) => (
              <Fragment key={letter + index}>
                <span
                  className={`${animatedIndices2.includes(index) ? 'text-animated' : 'opacity-0'} business-main-text-1`}
                >
                  {letter + '\u00A0'}
                </span>
                {index === 1 && <br />}
              </Fragment>
            ))}
          </p>
          <p style={{ marginTop: 12, color: "black", whiteSpace: "nowrap", wordBreak: 'break-word' }} className="business-main-text-2">
            <span className={`ropik-word left ${stage >= 1 ? "move" : ""} ${stage >= 2 ? "hide" : ""}`}>WASTE</span>
            <span className={`ropik-word ${stage >= 1 ? "move" : ""} ${stage >= 2 ? "hide" : ""}`}>+</span>
            <span className={`ropik-word right ${stage >= 1 ? "move" : ""} ${stage >= 2 ? "hide" : ""}`}>UNIVERSE</span>
            <span className={`ropik-merged ${stage >= 2 ? "show" : ""}`}>“WASTEVERSE”</span>
          </p>
          {/* <p style={{ marginTop: 20 }}>
            {animationTextArray2.map((letter, index) => (
              <span key={letter + index} className={`${animatedIndices2.includes(index) ? 'text-animated' : 'opacity-0'} business-main-text-3`}>{letter + '\u00A0'}</span>
            ))}
          </p> */}
          {/* <p style={{ marginTop: 20 }}>
            {animationTextArray3.map((letter, index) => (
              <span key={letter + index} className={`${animatedIndices3.includes(index) ? 'text-animated' : 'opacity-0'} business-main-text-4`}>{letter}</span>
            ))}
          </p> */}
        </div>
        <img className="transparency-layer" style={{ zIndex: 20, position: "absolute", bottom: 0, width: '100%' }} src={bottomTransparencyLayer} />
      </section>
      <div id="sec_1_2" className="business-background" style={{ width: '100%', position: "relative", paddingBottom: 200 }}>
        <img className="transparency-layer" style={{ zIndex: 20, position: "absolute", top: 0, width: '100%' }} src={topTransparencyLayer} />
        <div className="inner-container" style={{ position: 'relative', zIndex: 21 }}>
          <div style={{ margin: '0 auto', textAlign: 'center' }}>
            <p className="business-sub-text-1" ref={(el) => (divRefs.current[19] = el)} style={{ wordBreak: "break-word", display: "flex", justifyContent: "center", flexWrap: "wrap", overflow: "hidden" }} >
              <span className="ropik-text-reveal">
                Global Smart Environmentally Friendly
              </span>
              <span className="ropik-text-reveal">
                ESG Platform "WASTEVERSE"
              </span>
            </p>
            <div ref={(el) => (divRefs.current[20] = el)}>
              <p className="ropik-fade-down business-sub-text-2" style={{ marginTop: 30 }}>전세계 최초 배출량 실측을 통한 스마트 수거플랫폼 “웨이스트버스”</p>
              <p className="ropik-fade-down business-sub-text-3" style={{ marginTop: 10 }}>
                IOT 기술기반 음식물쓰레기 부피측정용 스마트계측기를 자체 개발하여 실 배출량을 실시간 계측 후 데이터를 공유하며,
                <br />
                전국 음식점, 음식물수집운반업체, 처리장, 재활용업체와 함께 상생하는 플랫폼입니다.
              </p>
            </div>
            <div ref={(el) => (divRefs.current[21] = el)} style={{ display: "flex", justifyContent: "center", marginTop: 80 }}>
              <button className="ropik-fade-in" style={{ padding: '16px 46px', borderRadius: 90, backgroundColor: 'white', display: 'flex', gap: 30, alignItems: "center", border: 'none' }} onClick={() => {
                history.push(`/main?menu=service-introduction`)
              }}>
                <span style={{ color: '#1F2D3D', fontWeight: '600', fontSize: 18, lineHeight: '150%' }}>웨이스트버스 소개</span>
                <img src={rightArrow} />
              </button>
            </div>
          </div>
        </div>
        <div className="inner-container" style={{ height: 380, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: 0, height: 80, border: '2px solid rgba(255, 255, 255, 0.3)' }} />
        </div>
        <div id="sec_1_3" className="inner-container">
          <div ref={(el) => (divRefs.current[0] = el)} className={`ropik-fade-up`} style={{ textAlign: 'center', margin: '0 auto' }}>
            <p className="business-sub-text-4">The core values of Wasteverse</p>
            <p className="business-sub-text-5" style={{ marginTop: 10 }}>눈대중으로 측정하고 청구하는<br />시대는 끝났다!</p>
            <p className="business-sub-text-6" style={{ marginTop: 10 }}>IoT가 바꾸는 음식물 폐기물 관리 혁신, 이제 실배출량 그대로!<br />분쟁 없는 공정한 시스템 웨이스트버스의 핵심가치</p>
          </div>
          <div style={{ marginTop: 80, width: '100%', display: "flex", justifyContent: 'center', gap: '50px 30px', flexWrap: 'wrap' }}>
            {section1.map((item, index) => (
              <div ref={(el) => (divRefs.current[index + 1] = el)} className={`ropik-fade-up`} key={'main_section1' + index} style={{ width: 380 }}>
                <div style={{ backgroundImage: `url(${item.img})`, width: '100%', height: 230, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.4)' }}>
                  <p style={{ fontWeight: '700', fontSize: 20, lineHeight: '130%', top: 148, left: 30, color: 'white', position: 'absolute' }}>
                    {item.title.split('\n').map((line, i) => (
                      <Fragment key={line + i}>
                        {line}
                        <br />
                      </Fragment>
                    ))}
                  </p>
                </div>
                <p style={{ marginTop: 20, fontWeight: '500', fontSize: 15, lineHeight: '150%', color: 'white' }}>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="inner-container" style={{ height: 380, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: 0, height: 80, border: '2px solid rgba(255, 255, 255, 0.3)' }} />
        </div>
        <div id="sec_1_4" className="inner-container">
          <div ref={(el) => (divRefs.current[4] = el)} className={`ropik-zoom-in`} style={{ textAlign: 'center', margin: '0 auto' }}>
            <p className="business-sub-text-7" >Wasteverse’s Innovative Technologies</p>
            <p className="business-sub-text-8" style={{ marginTop: 10 }}>웨이스트버스는 IoT·데이터·자동화로<br />음식물 폐기물 문제를 해결합니다.</p>
          </div>
          <div style={{ marginTop: 80, width: '100%', display: "flex", justifyContent: 'center', gap: '50px 30px', flexWrap: 'wrap' }}>
            {section2.map((item, index) => (
              <div ref={(el) => (divRefs.current[5 + index] = el)} className={`ropik-zoom-in`} key={'main_section2' + index} style={{ width: 380 }}>
                <div style={{ backgroundImage: `url(${item.img})`, width: '100%', height: 230, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.4)' }}>
                  <p style={{ fontWeight: '700', fontSize: 20, lineHeight: '130%', top: 148, left: 30, color: 'white', position: 'absolute' }}>
                    {item.title.split('\n').map((line, i) => (
                      <Fragment key={line + i}>
                        {line}
                        <br />
                      </Fragment>
                    ))}
                  </p>
                  {index === 3 &&
                    <p className="font-pridi" style={{ fontSize: 60, fontWeight: '700', lineHeight: '150%', color: '#54F4DEB2', position: 'absolute', top: 70, left: 0, right: 0, margin: '0 auto', width: 'fit-content' }}>ESG</p>
                  }
                </div>
                <p style={{ marginTop: 20, fontWeight: '600', lineHeight: '150%', fontSize: 18, color: '#8FF9EB' }}>{item.subTitle}</p>
                <p style={{ marginTop: 5, fontWeight: '500', fontSize: 15, lineHeight: '150%', color: 'white' }}>{item.content}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="inner-container scroll-container algorithm-container" style={{ margin: '80px auto 0' }}>
          <div style={{ width: 1200, height: 289, top: 29, position: 'relative', borderRadius: 20, border: '3px dashed #66F6E3', boxSizing: 'border-box', marginTop: 29 }}>
            <img style={{ position: "absolute", top: 36, left: 156, zIndex: 80 }} src={blueBottomArrow} />
            <img style={{ position: "absolute", bottom: 36, left: 156, zIndex: 80 }} src={orangeTopArrow} />
            <img style={{ position: "absolute", bottom: 36, right: 491, zIndex: 80 }} src={orangeTopArrow} />
            <img style={{ position: "absolute", bottom: 36, right: 314, zIndex: 80 }} src={orangeTopArrow} />
            <img style={{ position: "absolute", bottom: 36, right: 133, zIndex: 80 }} src={greenBottomArrow} />
            <div style={{ width: 180, height: 60, position: 'absolute', left: 75, top: -29, backgroundColor: '#6341E8', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
              <p style={{ fontWeight: '600', fontSize: 16, lineHeight: '150%', color: 'white' }}>B2C사업</p>
            </div>
            <div style={{ width: 290, height: 60, position: 'absolute', left: 0, right: 0, margin: '0 auto', top: -29, backgroundColor: 'black', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
              <img src={logoWhite} />
            </div>
            <div style={{ width: 1050, height: 185, position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, margin: 'auto', display: "flex" }}>
              <div style={{ width: 180, height: '100%', backgroundColor: 'white', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <p style={{ fontWeight: '700', fontSize: 18, lineHeight: '150%', color: '#1F2D3D' }}>배출</p>
                  <p style={{ marginTop: 4, fontWeight: '500', fontSize: 14, lineHeight: '130%', color: '#1F2D3DB2' }}>개별 음식점, 프랜차이즈<br />본사, 병원, 학교, 공장,<br />감량사업자 등<br />(약 83만개)</p>
                </div>
              </div>
              <div style={{ width: 39, height: '100%', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                <img src={whiteRightArrow} />
              </div>
              <div style={{ width: 294, height: '100%', position: 'relative' }}>
                <div style={{ width: '100%', height: 90, borderRadius: 14, backgroundColor: '#003FA8', position: "absolute", top: 0 }}>
                  <p style={{ fontWeight: '600', fontSize: 16, lineHeight: '150%', color: 'white', marginTop: 15, textAlign: "center" }}>전산 행정 간소화 시스템</p>
                  <p style={{ fontSize: 14, lineHeight: '150%', color: '#FFFFFFB2', textAlign: "center" }}>(계약, 정산, 홍보, 서류업무 등)</p>
                </div>
                <div style={{ boxShadow: '0px 4px 20px 0px #0000001A', width: 250, height: 52, borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center', backgroundColor: 'white', position: "absolute", top: 0, bottom: 0, left: 0, right: 0, margin: 'auto', zIndex: 60 }}>
                  <p style={{ fontWeight: '600', fontSize: 16, lineHeight: '150%', color: '#1D40AE' }}>PLATFORM</p>
                </div>
                <div style={{ width: '100%', height: 90, borderRadius: 14, backgroundColor: '#008A78', position: "absolute", bottom: 0 }}>
                  <p style={{ fontWeight: '600', fontSize: 16, lineHeight: '150%', color: 'white', textAlign: 'center', marginTop: 40 }}>IOT 계측 디바이스</p>
                </div>
              </div>
              <div style={{ width: 39, height: '100%', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                <img src={whiteRightArrow} />
              </div>
              <div style={{ width: 140, height: '100%', backgroundColor: 'white', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <p style={{ fontWeight: '700', fontSize: 18, lineHeight: '150%', color: '#042EA4' }}>수집운반</p>
                  <p style={{ marginTop: 4, fontWeight: '500', fontSize: 14, lineHeight: '130%', color: '#042EA4B2' }}>전국 수집운반차량<br />등록업체<br />(약 1,500개)</p>
                </div>
              </div>
              <div style={{ width: 39, height: '100%', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                <img src={whiteRightArrow} />
              </div>
              <div style={{ width: 140, height: '100%', backgroundColor: 'white', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <p style={{ fontWeight: '700', fontSize: 18, lineHeight: '150%', color: '#6841EA' }}>처리</p>
                  <p style={{ marginTop: 4, fontWeight: '500', fontSize: 14, lineHeight: '130%', color: '#6841EAB2' }}>전국 처리장 업체<br />(약 300개)</p>
                </div>
              </div>
              <div style={{ width: 39, height: '100%', display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                <img src={whiteRightArrow} />
              </div>
              <div style={{ width: 140, height: '100%', backgroundColor: 'white', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
                <div style={{ textAlign: 'center' }}>
                  <p style={{ fontWeight: '700', fontSize: 18, lineHeight: '150%', color: '#00B39B' }}>수요</p>
                  <p style={{ marginTop: 4, fontWeight: '500', fontSize: 14, lineHeight: '130%', color: '#00B39BCC' }}>(퇴비, 비료, 사료,<br />바이오가스)</p>
                </div>
              </div>
            </div>
            <div style={{ width: 871, height: 60, position: 'absolute', left: 75, bottom: -29, backgroundColor: '#FB900D', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
              <p style={{ fontWeight: '600', fontSize: 16, lineHeight: '150%', color: 'white' }}>유통사업(식자재유통, 장비랜탈)</p>
            </div>
            <div style={{ width: 140, height: 60, position: 'absolute', right: 75, bottom: -29, backgroundColor: '#CB524B', borderRadius: 14, display: "flex", justifyContent: "center", alignItems: 'center' }}>
              <p style={{ fontWeight: '600', fontSize: 16, lineHeight: '150%', color: 'white' }}>탄소배출사업권</p>
            </div>
          </div>
        </div>
        <div className="inner-container" style={{ margin: '80px auto 0', position: 'relative' }}>
          <div style={{ margin: '0 auto', textAlign: 'center' }}>
            <p className="business-sub-text-9 ropik-fade-in" ref={(el) => (divRefs.current[22] = el)}>
              <span>"웨이스트버스"는 폐기물 처리 전과정을 하나의 디지털 시스템으로 연결하는</span>
              <br />
              <span>IoT(사물인터넷) 기반 혁신 ESG플랫폼입니다.</span>
            </p>
            <div ref={(el) => (divRefs.current[23] = el)} style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
              <button className="ropik-fade-in" style={{ padding: '16px 46px', borderRadius: 90, backgroundColor: 'white', display: 'flex', gap: 30, alignItems: "center", border: 'none' }} onClick={() => {
                history.push(`/main?menu=service-introduction`)
              }}>
                <span style={{ color: '#1F2D3D', fontWeight: '600', fontSize: 18, lineHeight: '150%' }}>상세안내 바로가기</span>
                <img src={rightArrow} />
              </button>
            </div>
          </div>
        </div>
        <div className="inner-container" style={{ height: 380, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: 0, height: 80, border: '2px solid rgba(255, 255, 255, 0.3)' }} />
        </div>
        <div className="inner-container" id="sec_1_5" style={{ position: "relative", zIndex: 40 }}>
          <div ref={(el) => (divRefs.current[10] = el)} className={`ropik-fade-up`} style={{ textAlign: 'center', margin: '0 auto' }}>
            <p className="business-sub-text-10">Social Value of the ESG Platform Wasteverse</p>
            <p className="business-sub-text-11" style={{ marginTop: 10 }}>ESG플랫폼 웨이스트버스의 사회적 가치</p>
          </div>
          <div className="business-section3-container">
            {section3.map((item, index) => (
              <div ref={(el) => (divRefs.current[11 + index] = el)} className={`ropik-fade-up`} key={'main_section3' + index} style={{ width: 550 }}>
                <div style={{ backgroundImage: `url(${item.img})`, width: '100%', height: 300, backgroundSize: 'cover', backgroundPosition: 'center', position: 'relative', boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.4)' }}>
                  <p style={{ fontWeight: '700', fontSize: 20, lineHeight: '130%', bottom: 40, left: 30, color: 'white', position: 'absolute' }}>
                    {item.title.split('\n').map((line, i) => (
                      <Fragment key={line + i}>
                        {line}
                        <br />
                      </Fragment>
                    ))}
                  </p>
                  {index === 1 &&
                    <img style={{ width: 140, height: 'auto', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, margin: 'auto', opacity: 0.6 }} src={logo} />
                  }
                </div>
                <p style={{ marginTop: 20, fontWeight: '600', lineHeight: '150%', fontSize: 18, color: '#8FF9EB' }}>{item.subTitle}</p>
                <p style={{ marginTop: 5, fontWeight: '500', fontSize: 15, lineHeight: '150%', color: 'white' }}>{item.content}</p>
              </div>
            ))}
          </div>
          <p className="business-sub-text-12 " ref={(el) => (divRefs.current[24] = el)} style={{ textAlign: "center", marginTop: 80 }}>
            <span className="ropik-text-reveal">이처럼 웨이스트버스는 IoT, 데이터, 자동화, ESG 연계 등 혁신 기술을 통합해</span>
            <span className="ropik-text-reveal">음식물류 폐기물 관리의 패러다임을 전환하고 있습니다.</span>
          </p>
        </div>
        <div className="inner-container" style={{ height: 380, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ width: 0, height: 80, border: '2px solid rgba(255, 255, 255, 0.3)' }} />
        </div>
        <div id="sec_1_6" className="inner-container">
          <div ref={(el) => (divRefs.current[16] = el)} className={`ropik-fade-up`}>
            <p className="business-sub-text-13" style={{ textAlign: "center" }}>Visit the Support Center for FAQs, news, and technical assistance.</p>
            <p className="business-sub-text-14" style={{ marginTop: 10, textAlign: "center" }}>웨이스트버스 플랫폼 입점안내 및 고객지원</p>
          </div>
          <div style={{ marginTop: 80, width: '100%', display: "flex", justifyContent: 'center', gap: '50px 30px', flexWrap: 'wrap' }}>
            {section4.map((item, index) => (
              <div ref={(el) => (divRefs.current[index + 17] = el)} className={`ropik-fade-up`} key={'main_section4' + index} style={{ width: 570, padding: 40, backgroundColor: '#00000099', borderRadius: 30, display: "flex", flexDirection: 'column', alignItems: 'center' }}>
                <img src={item.icon} />
                <p style={{ fontWeight: '700', fontSize: 22, lineHeight: '150%', color: "white", marginTop: 20, textAlign: "center" }}>{item.title}</p>
                <p style={{ fontSize: 15, lineHeight: '150%', color: "white", marginTop: 20, textAlign: "center", marginTop: 4 }}>
                  {item.content.split('\n').map((line, i) => (
                    <Fragment key={line + i}>
                      {line}
                      <br />
                    </Fragment>
                  ))}
                </p>
                <div className="store-entry-button-container">
                  <button className="store-entry-button" onClick={() => {
                    history.push(`/main?menu=${item.button1Url}`, { top: item.click1 })
                  }}>
                    <span style={{ color: '#1F2D3D', fontWeight: '600', fontSize: 16, lineHeight: '150%' }}>{item.button1}</span>
                    <img src={rightArrow} />
                  </button>
                  <button className="store-entry-button" onClick={() => {
                    history.push(`/main?menu=${item.button2Url}`, { top: item.click2 })
                  }}>
                    <span style={{ color: '#1F2D3D', fontWeight: '600', fontSize: 16, lineHeight: '150%' }}>{item.button2}</span>
                    <img src={rightArrow} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  )
};

export default BusinessIntroduction